export default __webpack_public_path__ + "static/media/Design-Skills_Wireframes-for-website.9b48466e.jpg";